









































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import SheetListTab from "../../components/SheetListTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { Sheet, Subject, SumupListCondition } from "../../modules/teacher/SumupList"


export interface Data {
  tabNo: number
  condition: SumupListCondition
  comboboxKinds: any[]
  sheets: Sheet[]
  totalCount: number
  KindEnum: Readonly<{TwentyMin: number; Various: number; Kimatsu: number}>
  errors: string[]
  isShow: boolean
}

export default defineComponent({
  components: {
    "sheet-list-tab": SheetListTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 2,
      condition: context.root.$store.state.sumupListCondition,
      comboboxKinds: context.root.$store.getters.getComboboxKinds(true).filter((x: any) => x.value != Common.KindEnum.Kimatsu),
      sheets: new Array<Sheet>(),
      totalCount: 0,
      KindEnum: Common.KindEnum,
      errors: [],
      isShow: false,
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/sumup_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
        state.totalCount = state.sheets.length > 0 ? state.sheets[0].at_full_count : 0;

        context.root.$store.commit("setSumupListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月') : "-";
    };

    /******************************
     * 未登録科目を画面表示文言にコンバート
     ******************************/

    const convertSubjectName = (subjects: Subject[]) => {

      var subject_name = "";
      subjects.forEach((x: Subject) => {
        subject_name = Common.stringConnection(subject_name, x.name, " ");
      });
      return subject_name;
    };

    /******************************
     * 集計ボタン押下
     ******************************/

    const sumupClick = async (sheet: Sheet) => {

      state.errors = [];

      if(!window.confirm(`試験ID[${sheet.sheet_group_key}]の集計処理を実行します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/sumup_list/sumup/${sheet.sheet_group_key}`).then(response => {
        alert("集計が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SumupListCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      if(context.root.$store.state.sumupListCondition == null){
        state.condition = new SumupListCondition();
        state.condition.nendo = context.root.$store.getters.getCurrentNendo();
      }else{
        state.condition = context.root.$store.state.sumupListCondition;
      }
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      search,
      searchClick,
      convertExecDate,
      convertSubjectName,
      sumupClick,
      clearCondition,
      changePage,
    }
  }
});
